/**
 * Sanitize error messages so raw server details never reach the UI.
 * Maps known patterns to user-friendly text; falls back to a generic message.
 */

const PATTERNS = [
  // Auth / session
  [/session.*expired|jwt.*expired|token.*expired/i, 'Your session has expired. Please sign in again.'],
  [/not authenticated|user not authenticated/i, 'Please sign in to continue.'],
  [/invalid.*credentials|invalid.*password/i, 'Invalid email or password. Please try again.'],
  [/email.*already.*registered/i, 'This email is already registered. Try signing in instead.'],
  [/popup.*blocked/i, 'Pop-up blocked by your browser. Please allow pop-ups for this site.'],

  // OAuth / social
  [/token.*validation.*failed.*forbidden/i, 'Your social account connection has expired. Please reconnect in Link Accounts.'],
  [/token.*not found|connect.*account.*first/i, 'Please connect your account first in Link Accounts.'],
  [/refresh.*failed/i, 'Unable to refresh your connection. Please reconnect your account.'],
  [/duplicate.*content/i, 'This content was already posted. Platforms don\'t allow duplicate posts.'],
  [/rate.*limit/i, 'Too many requests. Please wait a moment and try again.'],
  [/authentication.*cancelled/i, 'Authentication was cancelled.'],

  // Network / server
  [/fetch.*failed|network.*error|ECONNREFUSED|ENOTCONN/i, 'Unable to reach the server. Please check your internet connection.'],
  [/service.*role.*key|supabase_url/i, 'A server configuration issue occurred. Please try again later.'],
  [/500|internal.*server/i, 'Something went wrong on our end. Please try again.'],
  [/503|service.*unavailable/i, 'The service is temporarily unavailable. Please try again shortly.'],
  [/timeout/i, 'The request timed out. Please try again.'],
];

export function friendlyError(raw, fallback = 'Something went wrong. Please try again.') {
  if (!raw) return fallback;
  const msg = typeof raw === 'string' ? raw : raw?.message || String(raw);

  for (const [regex, friendly] of PATTERNS) {
    if (regex.test(msg)) return friendly;
  }

  // If the message looks like it came from the user-facing layer (short, no stack trace), pass it through
  if (msg.length < 120 && !msg.includes('at ') && !msg.includes('Error:')) {
    return msg;
  }

  return fallback;
}
